export const landFormHead = [
  "LAND_FORM.YEAR_OF_CHANGE",
  "LAND_FORM.PERCENTAGE_AFFECTED_AREA",
  "LAND_FORM.LAND_USE",
  "LAND_FORM.TILLAGE",
  "LAND_FORM.CARBON_INPUTS",
  "LAND_FORM.FOREST_TYPE",
];
